import { render } from "./shed_list.vue?vue&type=template&id=0875e68c&scoped=true"
import script from "./shed_list.vue?vue&type=script&lang=js"
export * from "./shed_list.vue?vue&type=script&lang=js"

import "./shed_list.vue?vue&type=style&index=0&id=0875e68c&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0875e68c"]])

export default __exports__